import { createIconComponent } from '../../factory/create-icon-component';
export const FilterIcon = createIconComponent(
  'FilterIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.3652 2H4.6348C3.73193 2 3 2.73193 3 3.6348C3 5.74665 4.01989 7.72849 5.73837 8.95598L7.66667 10.3333L7.66668 10.3333C8.30877 10.792 8.62982 11.0213 8.88894 11.2919C9.42476 11.8514 9.78657 12.5545 9.93043 13.3157C10 13.6838 10 14.0784 10 14.8674V20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20V14.8674C14 14.0784 14 13.6838 14.0696 13.3157C14.2134 12.5545 14.5752 11.8514 15.1111 11.2919C15.3702 11.0213 15.6912 10.792 16.3333 10.3333L18.2616 8.95598C19.9801 7.72849 21 5.74665 21 3.6348C21 2.73193 20.2681 2 19.3652 2Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.3652 2H4.6348C3.73193 2 3 2.73193 3 3.6348C3 5.74665 4.01989 7.72849 5.73837 8.95598L7.66667 10.3333L7.66668 10.3333C8.30877 10.792 8.62982 11.0213 8.88894 11.2919C9.42476 11.8514 9.78657 12.5545 9.93043 13.3157C10 13.6838 10 14.0784 10 14.8674V20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20V14.8674C14 14.0784 14 13.6838 14.0696 13.3157C14.2134 12.5545 14.5752 11.8514 15.1111 11.2919C15.3702 11.0213 15.6912 10.792 16.3333 10.3333L18.2616 8.95598C19.9801 7.72849 21 5.74665 21 3.6348C21 2.73193 20.2681 2 19.3652 2Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
